import React from 'react'
import { TextInput } from 'SRC/ui/FormElements'

const emailField = {
  id: 'email',
  name: 'email',
  label: 'Email'
}

export const Email = () =>
  <div className='form-email'>
    <TextInput {...emailField} />
  </div>
